import React from "react";
import "./style.scss";

function RichTextEditor({content}) {
  return (
    <div className="RichTextEditor" dangerouslySetInnerHTML={{__html: content.rich_text}} />
  );
}

export default RichTextEditor;
